import React, { useState, useEffect } from 'react';
import { Layout, Grid } from 'antd';
import { useSelector } from 'react-redux';
import { useLocalStorageState } from 'ahooks';
import { Header as NewAppHeader } from '../../app/shell/Header';
import { SideMenu } from '../../app/shell/side-menu/SideMenu';
import Header from '../../containers/Header';
import ActionPanel from '../../containers/ActionPanel';
import {
  BETA_TOGGLES,
  SOFT_ROLLBACK_TOGGLES,
} from '../../features/beta/screens/Beta';
import { useScreenName } from '../../shared/hooks/use-screen-name';
import { isWhitelabelAccount } from '../../shared/utils';

const { Content: AntdContent, Header: AntdHeader } = Layout;
const { useBreakpoint } = Grid;

export function PageLayout({
  children,
  apiClient,
  trackMethod,
  eventBus,
}: {
  children: JSX.Element;
  apiClient: unknown;
  trackMethod: (
    eventName: string,
    eventPayload?: string | number | object
  ) => void;
  eventBus: unknown;
}) {
  const screens = useBreakpoint();
  const currentMerchant = useSelector((state: any) => state.currentMerchant);
  const isWhitelabel = isWhitelabelAccount(currentMerchant?.whiteLabel);
  const screenName = useScreenName();

  const [showSoftRollbackMainMenu] = useLocalStorageState<boolean>(
    SOFT_ROLLBACK_TOGGLES.mainMenu.key,
    {
      listenStorageChange: true,
    }
  );

  const [sideMenuCollapsed, setSideMenuCollapsed] = useState(false);

  // Collapse menu when screen is smaller than md
  useEffect(() => {
    setSideMenuCollapsed(!screens.md);
  }, [screens.md]);

  const showOldMainMenu = showSoftRollbackMainMenu;

  return (
    <Layout className="as-PageLayout" style={{ minHeight: '100vh' }}>
      {showOldMainMenu ? (
        <>
          <AntdHeader className="as-PageHeader">
            <ActionPanel />
            <Header
              {
                // Note: We are using the spread operator to bypass
                // the props ts error, this will be fixed in the next step
                // we are going to use the correct types in new Header component
                ...({
                  apiClient,
                  eventBus,
                  trackMethod,
                } as any)
              }
            />
          </AntdHeader>
          <AntdContent className="as-PageContent">{children}</AntdContent>
        </>
      ) : (
        <>
          <SideMenu
            screenName={screenName}
            sideMenuCollapsed={sideMenuCollapsed}
          />
          <Layout>
            <NewAppHeader
              sideMenuCollapsed={sideMenuCollapsed}
              onSideMenuCollapseChange={setSideMenuCollapsed}
            />
            <AntdContent className="as-PageContent">{children}</AntdContent>
          </Layout>
        </>
      )}
    </Layout>
  );
}
